import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';
import Dialog from '../../common/components/Dialog';
import MapComponent from '../../common/components/MapComponent';
import { withNamespaces } from 'react-i18next';

class CenterDetailsLink extends Component {
	constructor(props) {
		super(props);
		this.showInfoDialog = this.showInfoDialog.bind(this);
		this.hideInfoDialog = this.hideInfoDialog.bind(this);
		this.state = {
			showInfoDialog: false
		};
	}

	showInfoDialog() {
		this.setState({
			showInfoDialog: true
		});
	}

	hideInfoDialog() {
		this.setState({
			showInfoDialog: false
		});
	}

	renderInfoDialog() {
		const { center } = this.props;

		const header = center && center.name;
		const body = center && <div>
			{center.address && <p><Glyphicon glyph='map-marker' /> {center.address}</p>}
			<p>{center.addressDescription}</p>
			{center.phoneNumber && <p><Glyphicon glyph='earphone' /> {center.phoneNumber}</p>}
			{center.email && <p><Glyphicon glyph='envelope' /> {center.email}</p>}
			{center.additionalInfo && <p> <Glyphicon glyph='info-sign' /> <span dangerouslySetInnerHTML={{ __html: center.additionalInfo }} /></p>}
			{center.latitude && center.longitude && <MapComponent
				latitude={center.latitude}
				longitude={center.longitude}
				isSingleMarker
			/>}
		</div>;

		return <Dialog show={this.state.showInfoDialog} onHide={this.hideInfoDialog} header={header} body={body} />;
	}

	render() {
		const { center, className, style, hideMapMarker } = this.props;
		const infoDialog = this.renderInfoDialog();

		return center ? <span className={className} style={style}>
			<a style={{ cursor: 'pointer' }} onClick={this.showInfoDialog}>{!hideMapMarker && <Glyphicon glyph='map-marker' />} {center.name}</a>
			{infoDialog}
		</span> : null;
	}
}

CenterDetailsLink.propTypes = {
	center: PropTypes.shape({
		name: PropTypes.string,
		address: PropTypes.string,
		addressDescription: PropTypes.string,
		phoneNumber: PropTypes.string,
		additionalInfo: PropTypes.string,
		latitude: PropTypes.number,
		longitude: PropTypes.number
	})
};

export default withNamespaces()(CenterDetailsLink);